/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState, useEffect } from 'react'
import "./Header.css"
import SwipeHandler from './SwipeHandler'

const Header = () => {
    const [toggle, showMenu] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
            
            // Update active nav based on scroll position
            const sections = document.querySelectorAll('section[id]');
            sections.forEach(section => {
                const sectionTop = section.offsetTop - 100;
                const sectionHeight = section.offsetHeight;
                const sectionId = "#" + section.getAttribute('id');
                
                if(window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                    setActiveNav(sectionId);
                }
            });
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle swipe gestures for mobile
    const handleSwipeUp = () => {
        if (!toggle) {
            showMenu(true);
        }
    };
    
    const handleSwipeDown = () => {
        if (toggle) {
            showMenu(false);
        }
    };
    
    return (
        <header className={scrolled ? "header scrolled" : "header"}>
            <SwipeHandler onSwipeUp={handleSwipeUp} onSwipeDown={handleSwipeDown} />
            <nav className="nav container">
                <a href="#home" className="nav_logo">Farhan</a>

                <div className={toggle ? "nav_menu show_menu" : "nav_menu"} >
                    <ul className="nav_list grid">
                        <li className="nav_item">
                            <a href="#home" 
                               className={activeNav === "#home" ? "nav_link active-link" : "nav_link"}
                               onClick={() => setActiveNav("#home")}>
                                <i className="uil uil-estate nav_icon"></i> Home
                            </a>
                        </li>
                        <li className="nav_item">
                            <a href="#about" 
                               className={activeNav === "#about" ? "nav_link active-link" : "nav_link"}
                               onClick={() => setActiveNav("#about")}>
                                <i className="uil uil-user nav_icon"></i> About
                            </a>
                        </li>
                        <li className="nav_item">
                            <a href="#skills" 
                               className={activeNav === "#skills" ? "nav_link active-link" : "nav_link"}
                               onClick={() => setActiveNav("#skills")}>
                                <i className="uil uil-file-alt nav_icon"></i> Skills
                            </a>
                        </li>
                        {/* <li className="nav_item">
                            <a href="#projects" 
                               className={activeNav === "#projects" ? "nav_link active-link" : "nav_link"}
                               onClick={() => setActiveNav("#projects")}>
                                <i className="uil uil-briefcase-alt nav_icon"></i> Projects
                            </a>
                        </li> */}
                        <li className="nav_item">
                            <a href="#contact" 
                               className={activeNav === "#contact" ? "nav_link active-link" : "nav_link"}
                               onClick={() => setActiveNav("#contact")}>
                                <i className="uil uil-message nav_icon"></i> Contact
                            </a>
                        </li>
                    </ul>
                    <i className="uil uil-times nav_close" 
                       onClick={() => showMenu(!toggle)}></i>
                </div>
                <div className="nav_toggle" 
                     onClick={() => showMenu(!toggle)}>
                    <i className="uil uil-apps"></i>
                </div>
            </nav>
        </header>
    )
}

export default Header